import React from 'react';
import styled from 'styled-components';

export const VendorLogoSvg = styled.svg``;

export const VendorLogo = () => (
  <VendorLogoSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 42" fill="none">
    <path
      fill="#fff"
      fillOpacity={0.3}
      d="M2.572 12.94h5.51c2.556 0 4.401.372 5.535 1.117 1.143.744 1.714 1.92 1.714 3.529 0 1.083-.28 1.985-.838 2.704-.558.72-1.362 1.172-2.412 1.358v.127c1.304.246 2.26.733 2.87 1.46.617.72.926 1.697.926 2.933 0 1.667-.584 2.975-1.752 3.923-1.16.94-2.776 1.409-4.85 1.409H2.573V12.94Zm3.035 7.667h2.92c1.27 0 2.196-.198 2.78-.596.584-.406.876-1.092.876-2.057 0-.872-.318-1.502-.952-1.892-.627-.389-1.625-.584-2.996-.584H5.607v5.13Zm0 2.463v5.878H8.83c1.27 0 2.226-.241 2.87-.723.651-.491.977-1.262.977-2.31 0-.966-.33-1.681-.99-2.146-.66-.466-1.663-.699-3.01-.699H5.608Zm19.373-1.663 4.392-8.467h3.301L26.49 24.302V31.5h-3.046v-7.097L17.285 12.94h3.301l4.393 8.467Z"
    />
    <g clipPath="url(#a)">
      <path fill="#FFA200" d="M81.888 0h1.81l6.846 4.279h-1.909L81.888 0Z" />
      <path fill="#FDE43B" d="M74.811 42h1.81l6.847-4.28h-1.91L74.812 42Z" />
      <path
        fill="url(#b)"
        d="m69.945 33.903 4.34-13.1 3.909 13.1h9.528L86.51 37.26c-.936.218-1.47.312-2.424.428-.994.12-2.559.165-2.559.165H54.659c-2.02 0-3.266 0-5.253-.626-1.15-.362-1.885-.855-2.457-1.547a3.434 3.434 0 0 1-.774-1.777h23.77Z"
      />
      <path
        fill="url(#c)"
        d="M54.423 6.88c.723-.607 1.194-.884 2.054-1.284.875-.408 2.357-.758 2.357-.758l-1.145 3.39-2.963 11.027-4.04 14.648h-4.511s0-2.822.235-3.818c1.27-5.387 1.582-5.86 2.996-11.06.826-3.035 1.347-4.74 2.223-7.702.794-2.689 1.212-3.118 2.794-4.444Z"
      />
      <path
        fill="url(#d)"
        d="m86.712 8.229-3.606 13.034L78.463 8.23H57.656l1.178-3.39s1.041-.213 1.717-.297c.667-.082 1.717-.14 1.717-.14l28.417-.132c2.02 0 3.266.009 5.252.634 1.151.363 1.886.856 2.458 1.547.712.86.708 1.778.708 1.778H86.712Z"
      />
      <path
        fill="url(#e)"
        d="M90.92 35.187c-.722.605-1.194.883-2.053 1.283a9.574 9.574 0 0 1-2.357.79l1.145-3.423 2.963-11.027 4.04-14.647h4.444s-.007 1.994-.168 3.259c-.297 2.336-4.333 17.477-5.219 19.32-.886 1.845-1.213 3.118-2.794 4.445Z"
      />
      <path fill="url(#f)" d="m81.888 0 6.766 4.288-13.667.106L81.887 0Z" />
      <path fill="url(#g)" d="m74.81 42-6.894-4.394h13.821L74.811 42Z" />
      <path fill="url(#h)" d="M65.933 8.229h3.204l-6.898 25.674h-3.203l6.897-25.674Z" />
      <path fill="url(#i)" d="M53.581 14.878h11.583v3.225H53.58v-3.225Z" />
      <path fill="#FFF348" d="m78.563 33.903-4.279-13.1 2.633 13.1h1.646Z" />
      <path fill="#FFA200" d="m87.582 8.229-4.476 13.034L85.903 8.23h1.68Z" />
      <path
        fill="#FFF348"
        d="m98.097 10.204.128-.924a3.88 3.88 0 0 0-2.985-4.316l-3.017-.685h1.049c.265 0 .53.028.79.085l2.15.466a4.409 4.409 0 0 1 3.473 4.309v.639c0 .565-.074 1.127-.22 1.673L94.046 31.67a7.33 7.33 0 0 1-5.161 5.177l-.586.159c-1.353.367-2.739.6-4.137.696l-.761.053 4.633-1.665a7.023 7.023 0 0 0 4.41-4.792l5.652-21.093Z"
      />
      <path fill="url(#j)" d="M51.408 33.903h-1.613l4.32-15.8h1.473l-4.18 15.8Z" />
      <path fill="#FFF349" d="M63.192 33.903h-1.613l6.846-25.674h1.514l-6.747 25.674Z" />
      <path fill="url(#k)" d="M63.192 33.903h-1.613l6.846-25.674h1.514l-6.747 25.674Z" />
      <path fill="#FFAA06" d="M56.51 14.878h-1.627l1.8-6.65h1.473l-1.646 6.65Z" />
      <path
        fill="#fff"
        d="M108.701 8.348s-2.538.393-3.265.68c-1.907.762-3.338 2.43-4.136 4.827-.239.715-3.314 12.169-3.719 13.873-.429 1.788-.429 3.147 0 4.04.5 1.014 1.323 1.586 2.801 1.932.644.154 1.871.202 7.044.238 8.033.072 9.332-.06 11.359-1.12 1.418-.751 2.693-2.432 3.396-4.518.359-1.037 3.588-13.146 3.85-14.41.644-3.099-.202-4.672-2.896-5.387-.655-.167-1.633-.203-7.366-.215-3.635-.011-7.068.06-7.068.06Zm9.035 6.877c-.167.704-2.932 10.966-3.051 11.323l-.131.394h-8.797c0-.072 2.742-10.322 3.052-11.419l.178-.62h8.832l-.083.322ZM130.187 8.229c-.286.858-5.245 19.785-5.364 20.465-.441 2.431.084 3.897 1.621 4.565 1.49.631 1.764.655 9.285.655 6.281 0 7.08-.024 8.045-.214 2.873-.584 4.41-1.884 5.555-4.673.262-.631 1.513-5.041 3.075-10.87 1.454-5.387 2.633-9.892 2.633-9.928H146.98l-2.491 9.237c-1.37 5.078-2.574 9.404-2.622 9.476h-8.641l2.515-9.238c1.371-5.053 2.491-9.392 2.491-9.475h-8.045ZM157.092 8.229c-.024.083-.405 1.633-.834 3.278-.429 1.633-.918 3.29-.954 3.396h7.939l-.084.263c-.048.155-1.18 4.35-2.515 9.332a417.593 417.593 0 0 1-2.658 9.476h8.224c.036-.143 1.252-4.696 2.611-9.774l2.496-9.273h7.885c.036-.107 1.299-5.065 1.728-6.698h-23.838Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={68.985}
        x2={77.086}
        y1={48.945}
        y2={2.857}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.38} stopColor="#FFA200" />
        <stop offset={1} stopColor="#FDE43B" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={52.692}
        x2={49.795}
        y1={18.103}
        y2={33.903}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAA06" />
        <stop offset={1} stopColor="#FFF348" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={66.944}
        x2={57.826}
        y1={18.104}
        y2={50.887}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAB00" />
        <stop offset={1} stopColor="#FFE600" stopOpacity={0} />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M45.122 0h134.755v42H45.122z" />
      </clipPath>
    </defs>
  </VendorLogoSvg>
);
